import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromHelp from '@appStore/help/reducers/help.reducer';
import * as fromGuides from '@appStore/help/reducers/guides.reducer';
import * as fromUserGuides from '@appStore/help/reducers/user-guides.reducer';
import * as fromRoot from '../../../reducers';
import { Guide } from '@model';

export interface HelpState {
  help: fromHelp.State;
  guides: fromGuides.State;
  userGuides: fromUserGuides.State;
}

export interface State extends fromRoot.State {
  help: HelpState;
}

export const reducers: ActionReducerMap<HelpState> = {
  help: fromHelp.reducer,
  guides: fromGuides.reducer,
  userGuides: fromUserGuides.reducer
};

export const getState = createFeatureSelector<HelpState>('help');

// Help
export const getHelpState = createSelector(
  getState,
  (state: HelpState) => state.help
);
export const getAllHelp = createSelector(
  getHelpState,
  fromHelp.getAll
);
export const getHelpLoaded = createSelector(
  getHelpState,
  fromHelp.getLoaded
);
export const getHelpLoading = createSelector(
  getHelpState,
  fromHelp.getLoading
);
export const getCurrentHelpState = createSelector(
  getHelpState,
  fromHelp.getCurrentState
);
export const getSelectedTab = createSelector(
  getHelpState,
  fromHelp.getSelectedTab
);
export const getCurrentContextualInfo = createSelector(
  getHelpState,
  fromHelp.getCurrentContextualInfo
);
export const getGlossarySearchTerm = createSelector(
  getHelpState,
  fromHelp.getGlossarySearchTerm
);
export const getGlossaryTagSearchTerm = createSelector(
  getHelpState,
  fromHelp.getGlossaryTagSearchTerm
);

// Guides
export const getGuidesState = createSelector(
  getState,
  (state: HelpState) => state.guides
);
export const getAllGuides = createSelector(
  getGuidesState,
  fromGuides._getAllGuides
);
export const getGuidesLoaded = createSelector(
  getGuidesState,
  fromGuides._getGuidesLoaded
);
export const getGuidesLoading = createSelector(
  getGuidesState,
  fromGuides._getGuidesLoading
);

// UserGuides
export const getUserGuidesState = createSelector(
  getState,
  (state: HelpState) => state.userGuides
);
export const getAllUserGuides = createSelector(
  getUserGuidesState,
  fromUserGuides._getAllUserGuides
);
export const getUserGuidesLoaded = createSelector(
  getUserGuidesState,
  fromUserGuides._getUserGuidesLoaded
);
export const getUserGuidesLoading = createSelector(
  getUserGuidesState,
  fromUserGuides._getUserGuidesLoading
);

// Combined Selectors
export const getCombinedGuideData = createSelector(
  getGuidesState,
  getUserGuidesState,
  (gState, ugState): Guide[] => {
    if (!gState.guidesLoaded || !ugState.loaded || !ugState.userGuides || !gState.guides) {
      return;
    }

    return gState.guides.map(g => {
      let read =
        (g.isStandardGuide && ugState.userGuides.length === 0) ||
        ugState.userGuides.find(
          ug => ug.guideId === g.id && g.isStandardGuide && new Date(ug.lastViewed) < new Date(g.changed)
        )
          ? false
          : true;

      return { ...g, isRead: read };
    });
  }
);
